import {initSelects} from "./Select.ts";
import {fadeIn, fadeOut, fadeOutFadeIn} from "./Animate.ts";
import {$, empty, getParentElementByClassName, hide, show} from "./Dom.ts";
import {$get, $postForm} from "./Ajax.ts";
import {SelecteurDeServices} from "./SelecteurDeServices.ts";
import {createModale, showModal} from "./Modal.ts";
import {createErrorNotification, createSuccessNotification} from "../../portail/js/Notifications.ts";
import {findCkeditorInstance} from "./Utils.ts";

const typeDocument = ['avis', 'preavis', 'arrete', 'recepisse', 'piece_jointe']

export function initMessagerieEnvoi(container: HTMLElement) {
    initSelects(container)
    fadeOutFadeIn($('#attente_en_cours'), $('#formmail_englobe'))
    initCreateMessageListeners()
}

function initCreateMessageListeners() {
    $('#doc_objet')?.addEventListener('change', handleTypeDocumentChanged)
    $('#formmail')?.addEventListener('submit', handleFormSubmit)
    $('#actualite_toogle')?.addEventListener('change', handleActualiteChanged)
    $('#btn-modal-selecteur-carnet')?.addEventListener('click', showSelecteurDeService)
}

function handleTypeDocumentChanged(event: DOMEvent<HTMLSelectElement>) {
    const value = event.target.value
    const manif = window.Openscop.manifPk
    const block_documents = $('#list_doc_objet')
    if (manif && block_documents) {
        if (typeDocument.includes(value)) {
            $get(window.Openscop.url_messagerie_doc_associe, {
                manif,
                [value]: 1
            }).then((response) => {
                let datadecode = JSON.parse(response.body);
                if (datadecode.length === 0) {
                    if (!block_documents.classList.contains('d-none')) {
                        fadeOut(block_documents).then(() => empty(block_documents))
                    }
                } else {
                    let display = `<div class="fr-select-group" id="doc_objet_container"><select id='list_doc_associe' name='doc_associe_link'>
                        <option value="" data-placeholder="true">Choissez le document concerné</option>`
                    for (let k = 0; k < datadecode.length; k++) {
                        display += `<option value="${datadecode[k].pk}">${datadecode[k].nom}</option>`
                    }
                    display += `</select></div>`
                    block_documents.innerHTML = display
                    fadeIn(block_documents)
                    initSelects(block_documents)
                }
            })
        } else {
            if (!block_documents.classList.contains('d-none')) {
                fadeOut(block_documents).then(() => empty(block_documents))
            }
        }
    }
}

function send_le_mail(data: FormData) {
    let url = data.get('actualite') ? window.Openscop.url_messagerie_envoi_actu : window.Openscop.url_messagerie_envoi_unique
    url += `?manif=${window.Openscop?.manifPk}`
    $postForm(url, data).then((response) => {
        // $('#msg_envoi_alert').html("<div class='alert alert-success'>Message envoyé, redirection en cours</div>")
        if (response.response.status === 200) {
            createSuccessNotification({message: 'Message envoyé'})
            $<HTMLElement>('#show_mail')?.click()
        } else {
            let message = ""
            if (response.response.status === 403) {
                message = response.response.statusText
            } else {
                message = "Erreur d'envoi du message"
            }
            createErrorNotification({message})
        }
    })
}

function handleFormSubmit(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    const data = new FormData(event.target)
    data.set('corps', findCkeditorInstance(event.target.elements['corps'].id).getData())
    if (validateEnvoiFormulaire(data)) {
        send_le_mail(data)
    }
}

function validateEnvoiFormulaire(data: FormData) {
    // reset des erreurs
    getParentElementByClassName($('#carnet'), 'fr-select-group')?.classList.remove('fr-input-group--error')
    getParentElementByClassName($('#destinataire_liste'), 'fr-select-group')?.classList.remove('fr-input-group--error')
    getParentElementByClassName($('#doc_objet'), 'fr-select-group')?.classList.remove('fr-input-group--error')
    getParentElementByClassName($('#msg_objet'), 'fr-input-group')?.classList.remove('fr-input-group--error')
    getParentElementByClassName($('#id_corps'), 'fr-input-group')?.classList.remove('fr-input-group--error')
    getParentElementByClassName($('#list_doc_associe'), 'fr-select-group')?.classList.remove('fr-input-group--error')

    let isValide = false
    let hasErrorDestinataires = true
    if (data.has('destinataire_liste') || data.has('destinataires')) {
        if (data.has('destinataire_liste')) {
            hasErrorDestinataires = !(data.get('destinataire_liste') !== "")
        }
        if (data.has('destinataires')) {
            hasErrorDestinataires = !(data.get('destinataires') !== "")
        }
    }
    const hasErrorDocObject = data.has('doc_objet') && data.get('doc_objet') === ""
    // @ts-ignore
    const hasErrorMessageObject = data.has('msg_objet') && data.get('msg_objet')?.length === 0
    // @ts-ignore
    const hasErrorCorpsObject = data.has('corps') && data.get('corps')?.length === 0
    const isActualite = data.has('actualite')

    let hasAvisDocumentError = false
    if(data.get('doc_objet') === "avis") {
        hasAvisDocumentError = !data.has('doc_associe_link') || data.get('doc_associe_link') === ""
    }

    if (isActualite) {
        if (!(hasErrorMessageObject || hasErrorCorpsObject)) {
            isValide = true
        }
    } else if (!(hasErrorDestinataires || hasErrorDocObject || hasErrorMessageObject || hasErrorCorpsObject || hasAvisDocumentError)) {
        isValide = true
    }
    if (!isValide) {
        if (!isActualite && hasErrorDestinataires) {
            getParentElementByClassName($('#destinataire_liste')!, 'fr-select-group')?.classList.add('fr-input-group--error')
            getParentElementByClassName($('#carnet')!, 'fr-select-group')?.classList.add('fr-input-group--error')
        }
        // le formdata retourne le placeholder...
        if (!isActualite && (hasErrorDocObject || hasAvisDocumentError)) {
            getParentElementByClassName($('#doc_objet')!, 'fr-select-group')?.classList.add('fr-input-group--error')
        }
        if (hasErrorMessageObject) {
            getParentElementByClassName($('#msg_objet')!, 'fr-input-group')?.classList.add('fr-input-group--error')
        }
        if (hasErrorCorpsObject) {
            getParentElementByClassName($('#id_corps')!, 'fr-input-group')?.classList.add('fr-input-group--error')
        }
    }
    return isValide
}

function handleActualiteChanged(event: DOMEvent<HTMLInputElement>) {
    const target = event.target
    if (!target.checked) {
        fadeOut($('#actu_block'))
        fadeIn($('.desti_block'))
        fadeIn($('#doc_objet_block'))
        fadeIn($('#list_doc_objet'))
        fadeIn($("#btn-modal-selecteur-carnet"))
    } else {
        fadeIn($('#actu_block'))
        fadeOut($('.desti_block'))
        fadeOut($('#doc_objet_block'))
        fadeOut($('#list_doc_objet'))
        fadeOut($("#btn-modal-selecteur-carnet"))
    }
}

function showSelecteurDeService() {
    const modale = createModale('carnet_messagerie', {
        title: window.Openscop.selecteur.messagerie.modal_title,
    })
    if (modale) {
        let selecteur: SelecteurDeServices
        if(!window.Openscop.selecteur.messagerie_existant){
                    selecteur =  new SelecteurDeServices({
                ...window.Openscop.selecteur.messagerie
            })
            window.Openscop.selecteur.messagerie_existant = SelecteurDeServices
        }
        else {
            selecteur = window.Openscop.selecteur.messagerie_existant
        }
        showModal('carnet_messagerie', {
            disableScroll: true,
        })

    }
}